<!--  -->
<template>
  <div class="container">
     <div class="route-btn-box">
       <div v-if="prevId != null" class="prev-box" @click="toRouterName(routerName, prevId)">{{prevTitle}}</div>
       <div v-if="nextId != null" class="next-box" @click="toRouterName(routerName, nextId)">{{nextTitle}}</div>
     </div>
  </div>
</template>

<script>
export default {
  name: '',
  data () {
    return {
    }
  },

  props: ['prevId', 'prevTitle', 'nextId', 'nextTitle', 'routerName'],

  watch: {},

  components: {},

  computed: {},

  created () {},

  methods: {
    toRouterName(routerName, id) {
      if (routerName === 'NewsPage') {
        this.$router.push({ name: routerName, query: {newsId: id} });
      } else if (routerName === 'JobPage') {
        this.$router.push({ name: routerName, query: {jobId: id} });
      }
      $('html,body').animate({scrollTop: 0}, 500)
    }
  }
}

</script>
<style lang='scss' scoped>
.container {
  .route-btn-box {
    margin-top: 20px;
    font-size: 18px;
    font-weight: 600;
    line-height: 25px;
    color: #fbabc7;
    .prev-box {float:left; cursor: pointer;}
    .prev-box:hover {font-weight: 900; color: #FD4E7F; }
    .next-box {float:right; cursor: pointer;}
    .next-box:hover {font-weight: 900; color: #FD4E7F}
  }
}
</style>


// WEBPACK FOOTER //
// src/components/routeBtn/routeBtn.vue